/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import * as Cookies from 'js-cookie'
import { APP_CONSTANT } from '../../constants'

interface IUserService {
  isValidToken(): boolean
  redirectToLogin(): void
}

class UserService implements IUserService {
  isValidToken = (): boolean => {
    return Cookies.get(APP_CONSTANT.SESSION_TOKEN) !== undefined
  }

  redirectToLogin = (): void => {
    window.location.assign(APP_CONSTANT.LOGIN_DOMAIN)
  }
}

export default UserService
